/**
 * The community terms every member agrees to before an account exists.
 *
 * Bumping TERMS_VERSION re-prompts everyone: profiles record the version that
 * was accepted, so a material change is not silently assumed to be agreed.
 *
 * The no-tolerance wording is not decorative. App Store guideline 1.2 requires
 * that the terms make clear there is no tolerance for objectionable content or
 * abusive members, and that the operator removes offending content and ejects
 * the member within 24 hours of a report.
 */
export const TERMS_VERSION = '2026-08-04';

export const TERMS_SUMMARY =
  'There is no tolerance for objectionable content or abusive members. Reported content is reviewed and removed, and the member who posted it ejected, within 24 hours.';

export type TermsSection = Readonly<{ body: readonly string[]; title: string }>;

export const COMMUNITY_TERMS: readonly TermsSection[] = [
  {
    title: 'No tolerance for objectionable content',
    body: [
      '6am BKK has zero tolerance for objectionable content and for abusive members. This applies everywhere you can write or upload: your name, your bio, your photo, event titles and descriptions, and anything else another member can see.',
      'You must not post content that is hateful, harassing, threatening, sexually explicit, violent, discriminatory, or that targets anyone for who they are. You must not impersonate another person, post another person’s private information, or use the club to spam other members.',
    ],
  },
  {
    title: 'What happens when content is reported',
    body: [
      'Every member can report content and block another member from inside the app. Reports go straight to the club organisers.',
      'We review every report and act within 24 hours. Where a report is upheld we remove the content and eject the member who posted it. Ejected accounts cannot sign in again.',
    ],
  },
  {
    title: 'Blocking',
    body: [
      'Blocking a member removes their content from your view immediately and stops them appearing in your feed. Blocking also notifies the club organisers so we can review that member.',
    ],
  },
  {
    title: 'Your responsibility',
    body: [
      'You are responsible for everything you post. Running with the club is a real-world activity: run within your ability, follow local traffic laws, and look after the people around you.',
      'By continuing you confirm you are at least 16 years old and that you agree to these terms.',
    ],
  },
];
